{
  "de": {
    "chart": {
      "type": {
        "bar": "Balkendiagramm",
        "bubble": "Blasendiagramm",
        "doughnut": "Ringdiagramm",
        "horizontalBar": "Horizontales Balkendiagramm",
        "line": "Liniendiagramm",
        "multiAxis": "Mehrachsendiagramm",
        "pie": "Kreisdiagramm",
        "polarArea": "Polardiagramm",
        "radar": "Netzdiagramm",
        "stackedBar": "Gestapeltes Balkendiagramm"
      }
    }
  }
}
